<template>
  <div id="grid-digitacion">
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        >
        </carga-masiva>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select v-model="nivelValue" :items="nivelSelect" label="Nivel">
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="documentoValue"
            :items="documentoSelect"
            label="Documento"
          >
          </v-select>
        </v-flex>

        <v-btn fab dark color="teal" title="Filtrar detalle" @click="filter()">
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsDigitacion"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.idNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.documento }}</td>
                <td class="text-xs-left">{{ props.item.total }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consulta escaneo"
                    @click="
                      viewDigitacion(
                        props.item.idNivel,
                        props.item.tipoPrueba,
                        props.item.documento
                      )
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Consultar escaneo de cajas
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-digitacion",

  components: {
    AlertEmpty,
    Loading,
    DataAdjunto,
    CargaMasiva,
  },
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      selected: [],
      loading: false,
      loading1: false,
      tipeArchive: "",
      alerta: false,
      dialog: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "idNivel" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "Documento", sortable: false, value: "documento" },
        { text: "Total a Digitar", sortable: false, value: "total" },
        //{ text: "Digitados", sortable: false, value: "fecha" },
        { text: "Accion", sortable: false, value: "" },
      ],
      itemsDigitacion: [],
      usuarioLoggedTipe: "",
      idUserLogged: "",
      proceso: "",
      documentoSelect: [],
      documentoValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      nivelValue: null,
      nivelSelect: [],
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/digitacion/preProcessFile";
    this.apiSaveDocument = "/digitacion/saveMassive";
    this.apiDownloadDocument = "/digitacion/downloadPlantilla/";
    this.templateTitle = "PLANTILLA_DIGITACION";

    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDigitacionFilter() {
      return await axios
        .get("/digitacion/sumary/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loadNivelSelect();
      this.loadTipoPruebaSelect();
      this.loadDocumentoSelect();

      this.loading = true;

      this.itemsDigitacion = await this.loadDigitacionFilter();

      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsDigitacion.forEach(function (d) {
        let index = niv.findIndex((x) => x.name == d.name);
        if (index === -1) {
          niv.push(d.name);
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoPruebaSelect() {
      let tip = [];
      this.itemsDigitacion.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipo == d.tipo);
        if (index === -1) {
          tip.push(d.tipo);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    loadDocumentoSelect() {
      let rut = [];
      this.itemsDigitacion.forEach(function (d) {
        let index = rut.findIndex((x) => x.documento == d.documento);
        if (index === -1) {
          rut.push(d.documento);
        }
      });
      this.documentoSelect = rut;
    },
    clear() {
      this.nivelValue = "";
      this.tipoPruebaValue = "";
      //this.loadData();
    },
    filter() {
      this.filter = true;
      this.loadData();
    },
    viewDigitacion(idNivel, tipoPrueba, documento) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "DigitacionRegistra",
          params: {
            idNivel: idNivel,
            tipoPrueba: tipoPrueba,
            documento: documento,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
  },
};
</script>
